import moment from "moment";

const MessageContentBottom = ({ message }) => {
    if (message?.sendingType === "pending") return <i className="fa fa-clock-o"></i>;
    if (message?.sendingType === "error")
        return (
            <span className="text-danger">
                Sending Error <i className="fa fa-exclamation-circle text-danger"></i>
            </span>
        );
    return moment.unix(Math.floor(+(message?.create_time || Date.now() / 1000))).fromNow();
};

export default MessageContentBottom;
